import { render, staticRenderFns } from "./CompanyListForMailing.vue?vue&type=template&id=2b5fa8f9&scoped=true&"
import script from "./CompanyListForMailing.vue?vue&type=script&lang=js&"
export * from "./CompanyListForMailing.vue?vue&type=script&lang=js&"
import style0 from "./CompanyListForMailing.vue?vue&type=style&index=0&id=2b5fa8f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5fa8f9",
  null
  
)

export default component.exports